<template>
    <v-container>
        <v-card>
            <v-layout pa-2 wrap>
                <v-flex xs12>
                    <h1 class="text-xs-center">Local Data Management</h1>
                </v-flex>
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex xs12>
                            <span class="font-weight-bold">Upload LocalDB</span>
                        </v-flex>
                        <v-flex xs12>
                            <span>This will upload a copy of all HMS local data to the cloud where it can be retrieved.</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn :loading="uploadLocalDBLoading" @click="uploadLocalDB()">Upload</v-btn>
                        </v-flex>
                        <v-flex xs12 v-if="uploadLocalDBResult">
                            <v-alert :value="true" type="success">Local DB uploaded as "{{ uploadLocalDBResult.BlobName }}"</v-alert>
                        </v-flex>
                        <v-flex xs12 v-if="uploadLocalDBError">
                            <v-alert :value="true" type="error">{{ uploadLocalDBError }}</v-alert>
                        </v-flex>
                        <v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex xs12>
                            <span class="font-weight-bold">Save LocalDB</span>
                        </v-flex>
                        <v-flex xs12>
                            <span>This will save a copy of all HMS local data to the device's file storage.</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn :loading="saveLocalDBLoading" @click="saveLocalDB()">Save</v-btn>
                        </v-flex>
                        <v-flex xs12 v-if="saveLocalDBError">
                            <v-alert :value="true" type="error">{{ saveLocalDBError }}</v-alert>
                        </v-flex>
                        <v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 v-if="showImportLocalDb">
                    <v-layout wrap>
                        <v-flex xs12>
                            <span class="font-weight-bold">Import LocalDB</span>
                        </v-flex>
                        <v-flex xs12>
                            <span>Select a previously saved file containing HMS local data and replace all of your current HMS local data with it.</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn :loading="importLocalDBLoading" @click="importLocalDB()">Import</v-btn>
                        </v-flex>
                        <v-flex xs12 v-if="importLocalDBError">
                            <v-alert :value="true" type="error">{{ importLocalDBError }}</v-alert>
                        </v-flex>
                        <v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 v-if="showClearLocalDb">
                    <v-layout wrap>
                        <v-flex xs12>
                            <span class="font-weight-bold">Clear LocalDB</span>
                        </v-flex>
                        <v-flex xs12>
                            <span>This will clear all data from the current HMS local database.</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn :loading="clearLocalDBLoading" @click="clearLocalDB()">Clear</v-btn>
                        </v-flex>
                        <v-flex xs12 v-if="clearLocalDBError">
                            <v-alert :value="true" type="error">{{ clearLocalDBError }}</v-alert>
                        </v-flex>
                        <v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
import LocalDataService from "@/services/localDataService";

export default {
    data(){
        return {
            uploadLocalDBLoading: false,
            uploadLocalDBResult: null,
            uploadLocalDBError: null,
            saveLocalDBLoading: false,
            saveLocalDBError: null,
            importLocalDBLoading: false,
            importLocalDBError: null,
            clearLocalDBLoading: false,
            clearLocalDBError: null
        }
    },
    computed: {
        showImportLocalDb() {
            return this.$store.getters["UserStore/isGlobalAdmin"];
        },
        showClearLocalDb() {
            return true;
        }
    },
    methods: {
        async uploadLocalDB(){
            this.uploadLocalDBLoading = true;

            this.uploadLocalDBResult = null;
            this.uploadLocalDBError = null;
            try {
                this.uploadLocalDBResult = await LocalDataService.uploadLocalData();
            } catch (err){
                this.uploadLocalDBError = err;
            }

            this.uploadLocalDBLoading = false;
        },
        async saveLocalDB(){
            this.saveLocalDBLoading = true;

            this.saveLocalDBError = null;
            try {
                await LocalDataService.saveLocalData();
            } catch (err){
                this.saveLocalDBError = err;
            }

            this.saveLocalDBLoading = false;
        },
        async importLocalDB(){
            this.importLocalDBLoading = true;

            this.importLocalDBError = null;
            try {
                await LocalDataService.importLocalData();
            } catch (err){
                this.importLocalDBError = err;
            }

            this.importLocalDBLoading = false;
        },
        async clearLocalDB() {
            this.clearLocalDBLoading = true;
            
            this.clearLocalDBError = null;
            try {
                await LocalDataService.clearLocalData();
            } catch (err) {
                this.clearLocalDBError = err;
            }    

            this.clearLocalDBLoading = false;
        }
    }
}
</script>